import Phaser from "phaser";
import { GameState } from "../state/GameState";
import { Tex } from "../ui/textures";
import { makeButton } from "../ui/widgets";

interface ConqueredData {
  next?: string;
  nextData?: Record<string, unknown>;
}

export class RegionConqueredScene extends Phaser.Scene {
  constructor() {
    super("RegionConquered");
  }

  create(data: ConqueredData) {
    const { width, height } = this.scale;
    const next = data.next ?? "MarketSelect";
    const nextData = data.nextData;

    const bgKey = GameState.americaWon() ? Tex.regionUsaWon : Tex.regionUsaOpen;
    this.add.image(width / 2, height / 2, bgKey).setDisplaySize(width, height).setDepth(-1);

    this.add.rectangle(width / 2, height / 2, width, height, 0x000000, 0.4).setDepth(0);

    const banner = this.add
      .image(width / 2, height / 2 - 30, Tex.regionConquered)
      .setDepth(1)
      .setScale(0);

    const targetScale = Math.min((width * 0.75) / banner.width, 1);

    this.tweens.add({
      targets: banner,
      scale: { from: 0, to: targetScale },
      duration: 500,
      ease: "Back.easeOut",
      onComplete: () => {
        this.tweens.add({
          targets: banner,
          scale: targetScale * 1.03,
          duration: 1200,
          yoyo: true,
          repeat: -1,
          ease: "Sine.inOut",
        });
      },
    });

    const btn = makeButton(this, width / 2, height - 80, "Continue  ▶", () => {
      this.scene.start(next, nextData);
    }, { width: 240, fill: 0x3355aa });
    btn.setAlpha(0);
    this.tweens.add({ targets: btn, alpha: 1, delay: 600, duration: 400 });
  }
}
